import { Button } from "@/components/ui/button"
import { Share2, RefreshCcw, Users, CalendarCheck2, Upload, FolderOpen, BarChart3, Settings2 } from 'lucide-react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom';

// Animation style to match other sections
const fadeIn = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.8, ease: 'easeOut' }
};

export const MissionHubSection = () => {
  const navigate = useNavigate();
  return (
    <section className="py-20 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <motion.div 
            className="order-2 lg:order-1"
            {...fadeIn}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Your Volunteering & Impact Universe , Now Unified with CORAA
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              CORAA lets you bring all your current nonprofit partners, impact activities, and event formats , no matter how fragmented , into one centralized, always-on catalog.<br/>
              What used to live across Excel sheets, PDF decks, and emails now fuels a live, bookable, intelligence-ready experience.
            </p>

            <div className="space-y-6 mb-10">
              {[
                {
                  icon: Upload,
                  title: "Onboard Existing Partners in Minutes",
                  description: "Upload your current NPO roster and activities to CORAA , mapped, tagged, and activated."
                },
                {
                  icon: FolderOpen,
                  title: "Replace Static Decks with Dynamic Microsites",
                  description: "Share one live, branded link for all opportunities , no more ‘Can you resend the PDF?’"
                },
                {
                  icon: BarChart3,
                  title: "Plug Directly into CSR & Volunteering Strategy",
                  description: "Filter by region, SDG, theme, or partner history to align with corporate focus areas."
                },
                {
                  icon: Settings2,
                  title: "Smart Event & Partner Management",
                  description: "Automate sign-ups, confirmations, reporting inputs, and impact visibility , from one place."
                }
              ].map((feature, index) => (
                <motion.div 
                  key={index}
                  className="flex gap-4 items-start"
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: index * 0.12, ease: 'easeOut' }}
                >
                  <div className="w-10 h-10 rounded-lg bg-[#2E7D32]/10 flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-5 h-5 text-[#2E7D32]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">{feature.title}</h3>
                    <p className="text-gray-600 text-sm">{feature.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>

            <Button 
              className="bg-[#17863d] hover:bg-[#146c31] text-white font-bold text-lg px-8 py-4 rounded-lg transition-all duration-200 w-full max-w-xl mx-auto"
              onClick={() => navigate('/signup')}
            >
              Bring Your NPO Network Into CORAA , Start Free
            </Button>
          </motion.div>

          {/* Right side - Visual Representation */}
          <motion.div 
            className="order-1 lg:order-2"
            {...fadeIn}
          >
            <div className="relative rounded-2xl shadow-2xl overflow-hidden bg-[#13151a]">
              <img
                src="/images/mission-hub-interface.jpg"
                alt="Mission Hub Interface showing nonprofit opportunities"
                className="w-full"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
